import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const getLessonsTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "getLessons",
    onDone: {
      target: "idle",
      actions: assign((_ctx, evt) => ({
        lessonOptions: evt.data
      }))
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("getSectionAvailableItems", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
